// Copyright (c) 2023, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 Inc. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

export const APP_NAME = "Travel App";
export const APP_DESCRIPTION =
  "Manage passport, visa, travel requests, travel invoices";

export const APP_CONTEXT = "";

export const FILTER_DATE_FORMAT = "YYYY-MM-DD";

// TODO : update with relavant id
export const VISA_NOT_APPLICABLE_ID = {
  id: window.config?.DEPLOYMENT_ENVIRONMENT == "Prod" ? 332 : 40,
  label: "Visa Not Applicable",
};
export const NO_VALID_VISA_AVAILABLE_ID = {
  id: window.config?.DEPLOYMENT_ENVIRONMENT == "Prod" ? 333 : 41,
  label: "No Valid Visa Available",
};

export const QUERY_PARAMS_REGEX = /^[A-Z-a-z0-9]*$/i;

export const AUTH_CONFIG = {
  signInRedirectURL: window.config?.FRONTEND_BASE_URL,
  signOutRedirectURL: window.config?.FRONTEND_BASE_URL,
  clientID: window.config?.ASGARDEO_CLIENT_ID,
  baseUrl: window.config?.ASGARDEO_SERVER_ORIGIN,
  scope: ["openid", "email", "groups"],
};

// User configs - Customize according to the choice of user
export const USER_CUSTOM_CONFIGS = {
  LAUNCHPAD: false,
};

export const PRIVILEGES = {
  NEW_TRAVEL_REQUESTS: 1,
  ALL_TRAVEL_REQUESTS: 2,
  EDIT_TRAVEL_REQUEST: 3,
  EDIT_TRAVEL_STATUS: 4,
  EDIT_TRAVEL_AGENT: 5,
  EDIT_TRAVEL_VISA: 6,

  ADD_VISA: 7,
  VIEW_VISA_LIST: 8,
  VIEW_VISA_INFORMATION: 9,
  EDIT_VISA: 10,

  VIEW_TRAVEL_DOCUMENT_LIST: 11,
  VIEW_TRAVEL_DOCUMENT_INFORMATION: 12,
  EDIT_TRAVEL_DOCUMENT: 13,
  ADD_TRAVEL_DOCUMENT: 14,

  GET_HOTEL_BOOKINGS: 15,
  UPDATE_HOTEL_BOOKINGS: 16,
  DELETE_HOTEL_BOOKING: 17,

  AGENT_TRAVEL_REQUESTS: 18,

  VIEW_PROFILE: 19,
  VIEW_OWN_VISA: 20,
  ADD_OWN_VISA: 21,
  EDIT_OWN_VISA_TAGGED_PASSPORT: 22,
  VIEW_OWN_TRAVEL_DOCUMENT: 23,
  ADD_OWN_TRAVEL_DOCUMENT: 24,

  APP_PREFERENCES: 25,

  ADD_PERDIEMS: 26,
  DELETE_PERDIEMS: 27,
  VIEW_PERDIEMS: 28,

  ROLE_SETTINGS: 29,

  VIEW_TRAVEL_INVOICES: 30,
  ADD_TRAVEL_INVOICES: 31,

  INVOICE_HR_APPROVAL: 32,
  INVOICE_FINANCE_APPROVAL: 33,

  PUSH_INVOICES_TO_NS: 34,

  VIEW_FUNDING_SOURCES: 35,

  VIEW_OWN_TRAVEL_REQUEST: 36,
  VIEW_OWN_PERDIEMS: 37,
  VIEW_OWN_TRAVEL_INVOICES: 38,

  VIEW_ALL_INVOICES_PAGE: 39,
  
  PUSH_PER_DIEM_PAYMENTS_TO_NS: 40,
  VIEW_ALL_PER_DIEM_PAYMENTS_PAGE: 41,

  VIEW_PER_DIEM_PAYMENTS: 42,
  ADD_PER_DIEM_PAYMENTS: 43,
  EDIT_PER_DIEM_PAYMENTS: 44,

  VIEW_TRAVEL_CARDS: 45,
  ADD_TRAVEL_CARDS: 46,

  VIEW_OWN_PER_DIEM_PAYMENTS: 47,
  VIEW_OWN_TRAVEL_CARDS: 48,

  MY_TRAVEL_REQUESTS: 49,
};

export const APP_CONFIG = {
  PAGES: {
    APP: APP_CONTEXT,
    HOME: APP_CONTEXT + "/",
    NEW_TRAVEL_REQUESTS: APP_CONTEXT + "/new-travel-requests",
    ALL_TRAVEL_REQUESTS: APP_CONTEXT + "/all-travel-requests",
    EDIT_TRAVEL_REQUEST: APP_CONTEXT + "/manage-travel-request",
    ALL_INVOICES: APP_CONTEXT + "/all-invoices",
    ALL_PER_DIEM_PAYMENTS: APP_CONTEXT + "/all-per-diem-payments",
    VIEW_VISA_LIST: APP_CONTEXT + "/visas",
    VIEW_TRAVEL_DOCUMENT_LIST: APP_CONTEXT + "/travel-documents",
    MY_TRAVEL_REQUESTS: APP_CONTEXT + "/my-travel-requests",
    PROFILE: APP_CONTEXT + "/profile",
    REPORTS: APP_CONTEXT + "/reports",
    SETTINGS: APP_CONTEXT + "/settings",
    NOT_FOUND: APP_CONTEXT + "/not-found",
  },
  EMAILS: {
    GET_HELP_EMAIL_TO: "wso2-digital-team@wso2.com",
    GET_HELP_EMAIL_SUBJECT: `[HELP] ${APP_NAME}`,
  },
  QUERY_VALUES: {
    VIEW: "view",
    EDIT: "edit",
    ACCOUNT: "account",
    TAGS: "tags",
    ROLES: "roles",
  },
};

export const LAUNCHPAD_ITEMS = [
  {
    id: 1,
    title: "Photos",
    category: "Marketing",
    description: "Marketing application make your life easier",
    isStared: true,
    url: "https://apps.wso2.com/",
    icon: "https://purepng.com/public/uploads/large/purepng.com-photos-iconsymbolsiconsapple-iosiosios-8-iconsios-8-721522596102asedt.png",
  },
  {
    id: 2,
    title: "Camera",
    category: "General",
    description: "General applications",
    isStared: true,
    url: "https://apps.wso2.com/",
    icon: "https://i.pinimg.com/originals/e2/bc/2b/e2bc2b005d593253f62a4727d3da5d4f.png",
  },
  {
    id: 3,
    title: "Calender",
    category: "HR",
    description: "Human Resource application",
    isStared: true,
    url: "https://apps.wso2.com/",
    icon: "https://i.pinimg.com/originals/1c/18/61/1c1861046d8f837de76fa78fcad98b7a.png",
  },
  {
    id: 4,
    title: "Stocks",
    category: "Sites",
    description: "All recordes sites are here",
    isStared: false,
    url: "https://apps.wso2.com/",
    icon: "https://cdn0.iconfinder.com/data/icons/apple-apps/100/Apple_Stock-512.png",
  },
  {
    id: 5,
    title: "Videos",
    category: "Marketing",
    description: "Marketing application make your life easier",
    isStared: true,
    url: "https://apps.wso2.com/",
    icon: "https://purepng.com/public/uploads/large/purepng.com-videos-icon-ios-7symbolsiconsapple-iosiosios-7-iconsios-7-721522596692wqfcj.png",
  },
  {
    id: 6,
    title: "Music",
    category: "HR",
    description: "HR perspectives",
    isStared: true,
    url: "https://apps.wso2.com/",
    icon: "https://i.pinimg.com/originals/ae/2e/56/ae2e5651b74a00d5d31b8c6453fa3ebb.png",
  },
  {
    id: 7,
    title: "Voice",
    category: "Sites",
    description: "Marketing application make your life easier",
    isStared: true,
    url: "https://apps.wso2.com/",
    icon: "https://i.pinimg.com/originals/13/6f/6b/136f6b5e8bc194b681b591dc61e16b36.png",
  },
];